<template>
  <div class="auth-description">
    <h2 class="auth-title">
      {{ $t('Reset password') }}
    </h2>
    <div>
      <span class="text text-grey">
        {{ $t('Set a new password or go') }}
      </span>
      <router-link :to="{ name: 'login' }" class="text link">
        {{ $t('back to login') }}
      </router-link>
    </div>
    <Form class="login-form auth" :error="error" :error-text="error" @submit="submit">
      <div class="register-passwords formcell">
        <FormInput
          id="pass-input"
          v-model="password"
          type="password"
          :placeholder="$t('Enter your password')"
          :input-info="$t('At least 6 characters with number')"
          :label-text="$t('New password')"
          :success="samePasswords"
        />

        <FormInput
          id="pass2-input"
          v-model="password2"
          type="password"
          :error="$v.password2.$error"
          :error-message="$t('Passwords don’t match')"
          :placeholder="$t('Repeat your password')"
          :label-text="$t('Repeat')"
          :success="samePasswords"
        />
      </div>

      <button type="submit" class="btn-primary w-button w-full">
        <Spinner v-if="isLoading" size="20" />
        <span v-else>
          {{ $t('Restore access') }}
        </span>
      </button>

      <div>
        {{ $t('Want to log in?') }}
        <router-link :to="{ name: 'login' }" class="link">
          {{ $t('Log in') }}
        </router-link>
      </div>
    </Form>
  </div>
</template>

<script>
  import { validationMixin } from 'vuelidate';
  import factory from '@/utils/api/factory';
  import required from 'vuelidate/src/validators/required';
  import sameAs from 'vuelidate/src/validators/sameAs';
  import minLength from 'vuelidate/src/validators/minLength';
  import Form from '@/components/common/Form';
  import FormInput from '@/components/ui/FormInput';
  import Spinner from 'vue-simple-spinner';
  import parseError from '@/utils/formatting/parse-error';

  export default {
    name: 'Login',
    components: { FormInput, Form, Spinner },
    mixins: [validationMixin],
    data() {
      return {
        password: '',
        password2: '',
        isLoading: false,
        error: null,
      };
    },
    validations: {
      password: { required, minLength: minLength(6) },
      password2: { sameAsPassword: sameAs('password') },
    },
    computed: {
      samePasswords() {
        return this.$v.password.required && this.$v.password2.sameAsPassword;
      },
    },
    methods: {
      async submit() {
        this.$v.$touch();
        if (this.$v.$invalid) return;

        this.isLoading = true;
        this.error = null;

        try {
          await factory('recover_password').create({
            password: this.password,
            hash_string: this.$route.params.hash,
          });
          await this.$router.push({ name: 'login' });
        } catch (e) {
          try {
            const errors = Object.values(e.response.data)[0];
            if (errors) this.error = errors.length === 1 ? errors[0] : errors.join('\n');
          } catch (_) {
            this.error = parseError(e) || e;
          }
        }
        this.isLoading = false;
      },
    },
  };
</script>

<style scoped>
  .forgot-link {
    float: right;
    font-weight: normal;
    text-transform: none;
    letter-spacing: normal;
  }
</style>
